var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEh = function SvgIconEh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M1.19 6.782A11.95 11.95 0 0 0 0 11.999c0 1.87.428 3.64 1.19 5.218L12 18.26l10.81-1.043A11.95 11.95 0 0 0 24 11.999c0-1.87-.428-3.64-1.19-5.217L12 5.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M1.191 17.218A12 12 0 0 0 12.001 24a12 12 0 0 0 10.808-6.782z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.191 6.782H22.81A12 12 0 0 0 12 0 12 12 0 0 0 1.191 6.782"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12zM15.13 12A3.65 3.65 0 0 1 18 8.433a3.652 3.652 0 1 0 0 7.135A3.65 3.65 0 0 1 15.13 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.153 9.652.518 1.594h1.677l-1.357.986.519 1.594-1.357-.985-1.356.985.518-1.594-1.356-.986h1.676z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconEh;